import FadeIn from "../../Animation/FadeIn";
import classNames from "classnames";
var classes = {
    grid: 'grid lg:grid-cols-12',
};
var FormGrid = function (_a) {
    var children = _a.children, className = _a.className;
    return (<FadeIn>
        <div className="container">
          <div className={classNames(classes.grid, className)}>
              {children}
          </div>
        </div>
      </FadeIn>);
};
export default FormGrid;
